/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetQuestPhotosCountResponse
 */
export interface GetQuestPhotosCountResponse {
    /**
     * 
     * @type {number}
     * @memberof GetQuestPhotosCountResponse
     */
    analyticsPassed: number;
    /**
     * 
     * @type {number}
     * @memberof GetQuestPhotosCountResponse
     */
    analyticsFailed: number;
    /**
     * 
     * @type {number}
     * @memberof GetQuestPhotosCountResponse
     */
    adminPassed: number;
    /**
     * 
     * @type {number}
     * @memberof GetQuestPhotosCountResponse
     */
    adminFailed: number;
}

/**
 * Check if a given object implements the GetQuestPhotosCountResponse interface.
 */
export function instanceOfGetQuestPhotosCountResponse(value: object): value is GetQuestPhotosCountResponse {
    if (!('analyticsPassed' in value) || value['analyticsPassed'] === undefined) return false;
    if (!('analyticsFailed' in value) || value['analyticsFailed'] === undefined) return false;
    if (!('adminPassed' in value) || value['adminPassed'] === undefined) return false;
    if (!('adminFailed' in value) || value['adminFailed'] === undefined) return false;
    return true;
}

export function GetQuestPhotosCountResponseFromJSON(json: any): GetQuestPhotosCountResponse {
    return GetQuestPhotosCountResponseFromJSONTyped(json, false);
}

export function GetQuestPhotosCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestPhotosCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'analyticsPassed': json['analyticsPassed'],
        'analyticsFailed': json['analyticsFailed'],
        'adminPassed': json['adminPassed'],
        'adminFailed': json['adminFailed'],
    };
}

export function GetQuestPhotosCountResponseToJSON(json: any): GetQuestPhotosCountResponse {
    return GetQuestPhotosCountResponseToJSONTyped(json, false);
}

export function GetQuestPhotosCountResponseToJSONTyped(value?: GetQuestPhotosCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'analyticsPassed': value['analyticsPassed'],
        'analyticsFailed': value['analyticsFailed'],
        'adminPassed': value['adminPassed'],
        'adminFailed': value['adminFailed'],
    };
}

